export default __webpack_public_path__ + "static/media/ens-monthly-roundup-february-2023.0cd63947.md";